<template>
  <v-app>
    <DisconnectDialog :enable="disconnectDialogValue" :message="disconnectDialogMessage" />
    <component :is="layout">
      <router-view :layout.sync="layout" />
    </component>
    <Snackbar />
  </v-app>
</template>

<script>
import i18n from '@/plugins/i18n'
import DisconnectDialog from '@/components/Ui/DisconnectDialog.vue'
import Snackbar from '@/components/Ui/Snackbar'
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  components: {
    DisconnectDialog,
    Snackbar
  },
  mounted() {
    window.addEventListener('single-spa:app-change', event => {
      const mountedApp = Object.keys(event.detail.newAppStatuses)
      if (mountedApp[0] == '@leapsight/portal') {
        return (window.document.title = `${i18n.t(
          'portal.general.app_list.labels.strix'
        )} - ${i18n.t('portal.general.app_list.labels.apps.portal')}`)
      }
    })
  },
  computed: {
    ...mapGetters('auth', ['connection']),
    disconnectDialogValue() {
      return this.$store.state.ui.disconnectDialogValue
    },
    disconnectDialogMessage() {
      return this.$store.state.ui.disconnectDialogMessage
    }
  },
  data() {
    return {
      layout: 'div'
    }
  }
}
</script>
<style lang="scss">
#stepper {
  box-shadow: none;

  .v-stepper__header {
    box-shadow: none;
  }
  .v-stepper__label {
    display: flex !important;
  }
}
</style>
